import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MobileCTA from '../../components/feature/MobileCTA';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  const values = [
    { icon: 'ri-checkbox-circle-line', title: 'Quality Work', description: 'We take the time to do the job right. Good prep work, clean lines, and attention to detail.' },
    { icon: 'ri-message-3-line', title: 'Clear Communication', description: 'We keep you updated, answer your questions, and make sure you know what to expect.' },
    { icon: 'ri-time-line', title: 'Show Up on Time', description: "When we say we'll be there, we show up. We respect your time and your home." },
    { icon: 'ri-hand-heart-line', title: 'Fair Pricing', description: 'You get a clear estimate before we start. No surprises, no hidden fees.' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <MobileCTA />

      {/* Hero Section */}
      <section className="pt-28 pb-12 bg-[#1A2B4A]">
        <div className="max-w-[1200px] mx-auto px-6 text-center">
          <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-3">About Us</p>
          <h1 className="text-[44px] lg:text-[52px] font-extrabold text-white mb-4">
            Local Painting Company
          </h1>
          <p className="text-[17px] text-white/70 max-w-[600px] mx-auto leading-relaxed">
            Serving homeowners in Kalamazoo, Portage, and Southwest Michigan
          </p>
        </div>
      </section>

      {/* Main About Section */}
      <section className="py-14 bg-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div className="relative h-[460px] rounded-xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/9b11b87c1d7a1caccbb07c92b25dae07.jpg"
                alt="Joel Painting"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-5 left-5 bg-[#1A2B4A] text-white px-4 py-2.5 rounded-lg">
                <p className="text-[13px] font-bold">Hablamos Español 🇲🇽</p>
              </div>
            </div>
            <div>
              <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-3">Who We Are</p>
              <h2 className="text-[28px] lg:text-[32px] font-extrabold text-[#1A2B4A] mb-5">
                We're Here to Help with Your Painting Projects
              </h2>
              <div className="space-y-4 text-[15px] text-[#6B7280] leading-relaxed">
                <p>Joel Painting is a local painting company based in the Kalamazoo area. We work with homeowners who need interior painting, exterior painting, cabinet refinishing, and other residential painting services.</p>
                <p>We focus on doing quality work and making the process easy for you. That means showing up on time, keeping you updated, protecting your home and belongings, and cleaning up when we're done.</p>
                <p>We speak both English and Spanish, so you can talk to us in whichever language is more comfortable for you.</p>
                <p>If you're looking for a painter in Kalamazoo, Portage, Plainwell, Three Rivers, Otsego, or nearby areas, give us a call or text. We'll come take a look and give you a free estimate.</p>
              </div>
              <div className="flex gap-3 mt-7">
                <a href="tel:+12695551234" className="bg-[#1A2B4A] text-white px-6 py-2.5 rounded-lg font-bold text-[14px] hover:bg-[#2A3B5A] transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2">
                  <i className="ri-phone-line"></i> Call Us
                </a>
                <Link to="/contact" className="border-2 border-[#1A2B4A] text-[#1A2B4A] px-6 py-2.5 rounded-lg font-bold text-[14px] hover:bg-[#1A2B4A] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                  Get Estimate
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-12 bg-[#1A2B4A]">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-10">
            <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-2">Our Standards</p>
            <h2 className="text-[34px] font-extrabold text-white mb-2">What We Focus On</h2>
            <p className="text-[15px] text-white/60">These are the things that matter to us</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((value, index) => (
              <div key={index} className="bg-white/10 rounded-xl p-6 text-center hover:bg-white/15 transition-colors">
                <div className="w-12 h-12 bg-[#C8A96E]/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-2xl text-[#C8A96E]`}></i>
                </div>
                <h3 className="text-[16px] font-bold text-white mb-2">{value.title}</h3>
                <p className="text-[13px] text-white/60 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas Section */}
      <section className="py-12 bg-[#F8F7F5]">
        <div className="max-w-[1000px] mx-auto px-6 text-center">
          <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-2">Coverage</p>
          <h2 className="text-[32px] font-extrabold text-[#1A2B4A] mb-3">Where We Work</h2>
          <p className="text-[15px] text-[#6B7280] mb-8">We serve homeowners throughout Southwest Michigan, including:</p>
          <div className="flex flex-wrap justify-center gap-3 mb-7">
            {['Kalamazoo', 'Portage', 'Plainwell', 'Three Rivers', 'Otsego', 'Nearby Areas'].map((area, index) => (
              <div key={index} className="flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full shadow-sm">
                <i className="ri-map-pin-2-fill text-[#C8A96E] text-sm"></i>
                <span className="text-[14px] font-bold text-[#1A2B4A]">{area}</span>
              </div>
            ))}
          </div>
          <p className="text-[14px] text-[#6B7280]">Not sure if we cover your area? Give us a call and ask.</p>
        </div>
      </section>

      {/* Bilingual Section */}
      <section className="py-10 bg-[#10B981]">
        <div className="max-w-[800px] mx-auto px-6 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <i className="ri-translate-2 text-3xl text-white"></i>
            <h2 className="text-[28px] font-extrabold text-white">Hablamos Español</h2>
          </div>
          <p className="text-[15px] text-white/90 leading-relaxed">
            We speak both English and Spanish. Call, text, or meet with us in whichever language you prefer. We want to make sure you understand everything about your project.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-white">
        <div className="max-w-[700px] mx-auto px-6 text-center">
          <h2 className="text-[30px] lg:text-[36px] font-extrabold text-[#1A2B4A] mb-3">Need a Painter?</h2>
          <p className="text-[15px] text-[#6B7280] mb-7">Call or text us for a free estimate on your painting project</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="tel:+12695551234"
              className="w-full sm:w-auto bg-[#1A2B4A] text-white px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#2A3B5A] transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-lg"></i>
              (269) 555-1234
            </a>
            <Link
              to="/contact"
              className="w-full sm:w-auto bg-white border-2 border-[#1A2B4A] text-[#1A2B4A] px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#1A2B4A] hover:text-white transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              Request Free Estimate
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
